import React, { Fragment, useContext } from "react";
import { makeStyles } from "@material-ui/styles";

import { Typography } from "@material-ui/core";
import AppbarItem from "../Component/Appbar/AppbarItem";
import { LangContext } from "../Context/Langcontext";
import useReactRouter from "use-react-router";

const useStyle = makeStyles((theme) => ({
  rootForm: {
    height: "calc(100vh - 5rem)",
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    backgroundColor: "#f8f8f6",
    paddingTop: "5rem",
  },
  footer: {
    display: "flex",
    justifyContent: "flex-start",
    backgroundColor: "#f8f8f6",
    alignItems: "center",
    flexGrow: 1,
    height: "4.3rem",
    width: "100%",
  },
  symbol: {
    marginLeft: "2rem",
    color: "#595A5A",
    fontSize: "0.8rem",
    fontWeight: 200,
  },
  webtext: {
    color: "#595A5A",
    fontSize: "0.8rem",
    fontWeight: 200,
    margin: "0.5rem",
  },
  font: {
    color: "#595A5A",
    fontSize: "0.8rem",
    fontWeight: 400,
    cursor: "pointer",
  },
}));

const AppLayout = ({ children }) => {
  const classes = useStyle();
  const langContext = useContext(LangContext);
  const lang = langContext.lang.data;
  const { history } = useReactRouter();

  return (
    <Fragment>
      <AppbarItem>
        <main className={classes.rootForm}>
          {children}
          <div className={classes.footer}>
            <div style={{ display: "flex", alignItems: "center" }}>
              <Typography className={classes.symbol}>©</Typography>
              <Typography className={classes.webtext}>
                {`${
                  langContext.lang.locale === "en"
                    ? new Date().getFullYear()
                    : Number(new Date().getFullYear() + 543)
                } ${lang.MEA}`}
              </Typography>
            </div>
            <div style={{ flexGrow: 1 }} />
            <div
              style={{
                display: "flex",
                marginRight: "2rem",
                alignItems: "center",
              }}
            >
              <Typography
                className={classes.font}
                style={{
                  marginRight: "1rem",
                }}
                onClick={() => {
                  history.push("/terms");
                }}
              >
                {lang.Terms}
              </Typography>
              <Typography
                className={classes.font}
                onClick={() => {
                  history.push("/privacy");
                }}
              >
                {lang.Privacy}
              </Typography>
            </div>
          </div>
        </main>
      </AppbarItem>
    </Fragment>
  );
};

export default AppLayout;
